import React, { Component } from "react"

import {
    allRegionsExceptEU,
    euRegion,
    localRegions,
    federalRegions,
    federalStatesAndLocal,
    federalAndStates,
    usEURegion,
} from "shared/imports/regionConstants"

import { MAX_BILL_SEARCHIFY_SELECTIONS } from "shared/search/constants"

import {
    createProfileToggleFilter,
    createProfileToggleSingleFilter,
    datePickerGenericFilter,
    // sorting functions
    enumValueSort,
    enumOrderSort,
    createSchoolDistrictEnrollmentFilter,
} from "shared/search/containers/Filter/Filters"
import {
    enumGenericFilter,
    toggleGenericFilter,
    searchifySelectGenericFilter,
} from "shared/search/containers/Filter/FilterCreators"

import {
    OfficialFilterableListView,
    BillFilterableListView,
    SupporterFilterableListView,
    VoteFilterableListView,
    AmendmentFilterableListView,
    CommitteeFilterableListView,
    PublicOrganizationFilterableListView,
    UserFilterableListView,
    WitnessSearchifyFLV,
    IssueSearchifyFLV,
    CountySearchifyFLV,
    MunicipalitySearchifyFLV,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import {
    CommitteeSelect,
    BillSelect,
    VoteSelect,
    AmendmentSelect,
    OfficialSelect,
    WitnessSelect,
    UserSelect,
    PublicOrganizationSelect,
    ContactSelect,
    IssueSelect,
    MunicipalitySelect,
    CountySelect,
    SchoolDistrictSelect,
} from "app/static/frontend/selects/containers/PieSelect"

import { BillSupportedRegionSelect } from "app/static/frontend/selects/containers/EnumSelect"

import { getEventSupportedRegionOptions } from "shared/selects/helperFunctions"
import { usRegions } from "shared/imports/regionConstants"
// helpers
import { checkIfShouldShowSchoolBoard } from "shared/imports/permissionFunctions"

export class EventDatePickerStartFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "eventStartDate",
        filterKey: "when__gt",
        displayLabel: "Starts After",
        helpText: "Events scheduled after date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventDatePickerOnFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "eventOnDate",
        filterKey: "on_date",
        displayLabel: "Event Date",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventDatePickerEndFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "eventEndDate",
        filterKey: "when__lt",
        displayLabel: "Starts Before",
        helpText: "Events scheduled before date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "eventTypeFilter",
        filterKey: "event_type__in",
        enumItems: DjangIO.app.events.models.EventType.region_supported_items().filter((type) => {
            if (type.value === DjangIO.app.events.models.EventType.custom.value) {
                return false
            }
            // For School Boards, we need to check if the user doesn't have other local permissions.
            // This is due the overlapping between both permissions and what we actually need to show in the filter.
            const { isExclusivelySchoolBoard, canSeeSchoolBoards } = checkIfShouldShowSchoolBoard()
            const isSchoolBoardMeeting = type.value === DjangIO.app.events.models.EventType.school_board_meeting.value
            if (isExclusivelySchoolBoard) {
                return isSchoolBoardMeeting
            }
            if (!canSeeSchoolBoards && isSchoolBoardMeeting) {
                return false
            }

            // Include all other items by default.
            return true
        }),
        enumGroups: DjangIO.app.events.models.EventType.filter_groups,
        sortBy: enumOrderSort,
        regions: allRegionsExceptEU,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventTypeEUFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "eventTypeEUFilter",
        filterKey: "event_type__in",
        enumItems: DjangIO.app.events.models.EventType.region_supported_items().filter(
            (type) =>
                ![
                    DjangIO.app.events.models.EventType.custom.value,
                    DjangIO.app.events.models.EventType.other_type.value,
                ].includes(type.value),
        ),
        enumGroups: DjangIO.app.events.models.EventType.filter_groups.filter((type) => type.title !== "Custom"), // TODO: Delete this filter when Non-legislative EU Data added
        sortBy: enumOrderSort,
        regions: euRegion,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventChamberFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "eventChamberFilter",
        filterKey: "chamber__in",
        //region: has_federal,
        enumItems: DjangIO.app.models.CongressChamber.region_supported_items(),
        sortBy: enumValueSort,
        displayLabel: "Chamber",
        regions: federalAndStates,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventCommitteeMentionFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "eventCommitteeMentionFilter",
            filterKey: "about_committee",
            searchifyFLV: CommitteeFilterableListView,
            dataTypeLabel: "Committees",
            selectComponent: CommitteeSelect,
            regions: federalRegions,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventBillMentionFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "eventBillMentionFilter",
            filterKey: "about_bill",
            searchifyFLV: BillFilterableListView,
            dataTypeLabel: "Bills",
            selectComponent: BillSelect,
            regions: federalRegions,
            maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventVoteMentionFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "eventVoteMentionFilter",
            filterKey: "about_vote",
            searchifyFLV: VoteFilterableListView,
            dataTypeLabel: "Votes",
            selectComponent: VoteSelect,
            regions: federalRegions,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventAmendmentMentionFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "eventAmendmentMentionFilter",
            filterKey: "about_amendment",
            searchifyFLV: AmendmentFilterableListView,
            dataTypeLabel: "Amendments",
            selectComponent: AmendmentSelect,
            regions: federalRegions,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventWitnessMentionFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "eventWitnessMentionFilter",
            filterKey: "involving_witnesses",
            searchifyFLV: WitnessSearchifyFLV,
            dataTypeLabel: "Witnesses",
            selectComponent: WitnessSelect,
            regions: federalRegions,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventIssueMentionFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "issueMentionFilter",
            filterKey: "about_issue",
            dataTypeLabel: "Issues",
            regions: federalAndStates,
            searchifyFLV: IssueSearchifyFLV,
            selectComponent: IssueSelect,
            regions: usEURegion,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventCommitteeTranscriptsFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "eventCommitteeTranscriptsFilter",
        filterKey: "has_transcripts",
        displayLabel: "Transcript",
        trueText: "Yes",
        falseText: "No",
        permissions: [DjangIO.app.models.PermissionType.official_documents],
        regions: federalStatesAndLocal,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventCommitteeVerifiedTranscriptsFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "eventCommitteeVerifiedTranscriptsFilter",
        filterKey: "has_verified_transcripts",
        displayLabel: "Verified Transcript",
        trueText: "Yes",
        falseText: "No",
        permissions: [DjangIO.app.models.PermissionType.official_documents],
        regions: federalRegions,
        helpText:
            "Verified Transcripts are high quality transcripts that have been verified for accuracy by people. " +
            "They are only available for a select number of committees. Please refer to the Help Center for more information.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventPointPersonFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "eventPointPersonFilter",
            filterKey: "point_person_querymethod",
            searchifyFLV: UserFilterableListView,
            dataTypeLabel: "User",
            displayLabel: "Point Person",
            multi: false,
            selectComponent: UserSelect,
            permissions: [DjangIO.app.models.PermissionType.custom_events],
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventSchoolDistrictFilter extends Component {
    static defaultProps = {
        filterComponent: searchifySelectGenericFilter,
        uniqueFilterId: "eventSchoolDistrict",
        filterKey: "source_public_org",
        dataTypeLabel: "SchoolDistricts",
        selectComponent: SchoolDistrictSelect,
        searchifyFLV: PublicOrganizationFilterableListView,
        regions: localRegions,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const EventRepresentingSchoolDistrictEnrollmentMinFilter = createSchoolDistrictEnrollmentFilter({
    uniqueFilterId: "event_rep_sd_enrollment_min",
    filterKey: "associated_sd_min_enrollment",
    isMin: true,
})

export const EventRepresentingSchoolDistrictEnrollmentMaxFilter = createSchoolDistrictEnrollmentFilter({
    uniqueFilterId: "event_rep_sd_enrollment_max",
    filterKey: "associated_sd_max_enrollment",
    isMin: false,
})

export class EventSponsoringOrganizationFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "eventSponsoringOrg",
            filterKey: "sponsoring_org",
            searchifyFLV: PublicOrganizationFilterableListView,
            searchifyPermanentFilter: { org_only: true },
            dataTypeLabel: "Organization",
            displayLabel: "Sponsoring Organization",
            multi: false,
            selectComponent: PublicOrganizationSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventParticipatingOfficialsFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "eventParticipatingOfficialsFilter",
            filterKey: "participating_officials",
            searchifyFLV: OfficialFilterableListView,
            dataTypeLabel: "Officials",
            displayLabel: "Event Participants",
            selectComponent: OfficialSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventParticipatingUsersFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "eventParticipatingUsersFilter",
            filterKey: "participating_users",
            searchifyFLV: UserFilterableListView,
            dataTypeLabel: "Team Members",
            selectComponent: UserSelect,
            permissions: [DjangIO.app.models.PermissionType.custom_events],
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventParticipatingOrganizationsFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "eventParticipatingOrgsFilter",
            filterKey: "participating_public_organizations",
            searchifyFLV: PublicOrganizationFilterableListView,
            dataTypeLabel: "Organizations",
            selectComponent: PublicOrganizationSelect,
            permissions: [DjangIO.app.models.PermissionType.custom_contacts],
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventParticipatingSupportersFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "eventParticipatingSupportersFilter",
            filterKey: "participating_supporters",
            searchifyFLV: SupporterFilterableListView,
            dataTypeLabel: "Contacts",
            selectComponent: ContactSelect,
            permissions: [DjangIO.app.models.PermissionType.custom_contacts],
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventCountyFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "eventCountyFilter",
            filterKey: "for_counties",
            searchifyFLV: CountySearchifyFLV,
            dataTypeLabel: "Counties",
            selectComponent: CountySelect,
            regions: localRegions,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventMunicipalityFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "eventMunicipalityFilter",
            filterKey: "for_municipalities",
            searchifyFLV: MunicipalitySearchifyFLV,
            dataTypeLabel: "Municipalities",
            selectComponent: MunicipalitySelect,
            regions: localRegions,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EventInvisibleCommitteeFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "eventInvisibleCommitteeFilter",
            filterKey: "associated_with_committees_qs",
            searchifyFLV: CommitteeFilterableListView,
            invisible: true,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

// Profile-specfic filters
export const EventOrganizatonsFilter = createProfileToggleSingleFilter({
    uniqueFilterId: "eventOrganizatonsFilter",
    trueText: "Current Org Only",
    filterKeyMapping: {
        true: "sponsoring_organization",
    },
})

export const EventCommitteProfileFilter = createProfileToggleFilter({
    uniqueFilterId: "eventCommitteProfileFilter",
    trueText: "Committee + All Sub Committees",
    falseText: "Current Committee Only",
    filterKeyMapping: {
        true: "associated_with_committees",
        false: "source_committee",
    },
})

// Yes this is redundant, but we need a filter that also includes the federal region for copilot, which the state dataset doesn't have
export const EventSupportedRegionsFilter = (props) => {
    const FilterComponent = props.filterComponent

    return <FilterComponent {...props} />
}
EventSupportedRegionsFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    enumItems: getEventSupportedRegionOptions(),
    uniqueFilterId: "eventSupportedRegionsFilter",
    filterKey: "for_supported_regions",
    // Not actually Bill Specific
    selectComponent: BillSupportedRegionSelect,
    regions: usRegions,
    displayKey: "region_name",
}
